import request from '@/libs/request'

// 平台用户列表
export function adminUserList (data) {
  return request({
    url: `admin/list`,
    method: 'get',
    params: data
  })
}
// 角色
export function groupAll () {
  return request({
    url: `admin/getAllRole`,
    method: 'get'
  })
}

// 启用禁用用户
export function changeStatus (id) {
  return request({
    url: `admin/changeStatus/${id}`,
    method: 'post'
  })
}

// 删除平台用户
export function delUser (id) {
  return request({
    url: `admin/delete/${id}`,
    method: 'post'
  })
}

// 添加平台用户
export function addAdminUser (data) {
  return request({
    url: `admin/edit`,
    method: 'post',
    data: data
  })
}

// 平台用户信息
export function adminuserInfo (id) {
  return request({
    url: `admin/info/${id}`,
    method: 'get'
  })
}
// 更新个人信息
export function updateInfo (data) {
  return request({
    url: `admin/updateInfo`,
    method: 'post',
    data: data
  })
}
